import { NgModule } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { ListarDependenciasFuncionariosComponent } from './listar-dependencias-funcionarios.component';
import { ListarDependenciasFuncionariosRoutingModule } from './listar-dependencias-funcionarios.routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}

@NgModule({
    declarations: [ListarDependenciasFuncionariosComponent],
    imports: [
        FormsModule, ReactiveFormsModule,
        ListarDependenciasFuncionariosRoutingModule,
        SharedModule,
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        })
    ],
    entryComponents: []
})

export class ListarDependenciasFuncionariosModule { }